import Money16 from '@carbon/icons-react/es/money/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Tag } from 'components/atoms/tag';
import { CategoryName } from 'components/organisms/timesheets/common/category-name';
import { FormatTime } from 'components/organisms/timesheets/common/format-time';
import { Categories } from 'components/pages/timesheet-settings/categories';
import { from } from 'components/pages/timesheet-settings/categories/core';
import { BodyShort01, SingleLineEllipsis } from 'components/styles';
import { getRandomColor } from 'utils/get-random-color';
import { TimesheetTableTimeEntry } from '../../types';

const Time = styled.div`
  padding: var(--spacing-02) 0;
`;
const TagAndBillable = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);

  ${Tag} {
    flex: 1;
    display: inline-block;
    ${SingleLineEllipsis};
  }
`;

const MainRow = styled.div`
  background-color: var(--coolest-gray-10);
  display: flex;
  justify-content: space-between;
  color: var(--gray-80);
  padding: var(--spacing-03) var(--spacing-05);
  ${BodyShort01};

  ${Time} {
    padding: var(--spacing-02) 0;
  }

  ${TagAndBillable} {
    max-width: 70%;
  }
`;

export const SecondaryRow = styled.div`
  padding: var(--spacing-03) var(--spacing-05);
  color: #000;
  margin-bottom: var(--spacing-05);
`;

const GreenMoneyIcon = styled(Money16)`
  color: var(--green-50);
`;

interface Props {
  entry: TimesheetTableTimeEntry;
  className?: string;
  categories: Categories;
}
export const EntryDetail: FC<Props> = ({ entry, className, categories }) => {
  const category = entry.category?.categoryId
    ? from(categories).byId[entry.category?.categoryId][1]
    : null;

  return (
    <div className={className}>
      <MainRow>
        <Time>
          <FormatTime value={entry.minutes} />
        </Time>
        <TagAndBillable>
          {entry.category ? (
            <Tooltip title={category?.name ?? entry.category.categoryName}>
              <Tag color={getRandomColor(entry.category.categoryId)}>
                <CategoryName
                  name={category?.name ?? entry.category.categoryName}
                  deleted={category?.deleted}
                />
              </Tag>
            </Tooltip>
          ) : null}
          {entry.billable ? <GreenMoneyIcon /> : null}
        </TagAndBillable>
      </MainRow>
      {entry.notes != null && entry.notes.trim().length > 0 ? (
        <SecondaryRow>{entry.notes}</SecondaryRow>
      ) : null}
    </div>
  );
};
